module.exports = __webpack_public_path__ + "img/logo-white.d8d57ce8.png";